<div *ngIf="errorMsg$ | async as errorMsg" class="banner banner--error">
    <span class="banner__msg">{{ errorMsg }}</span>
</div>
